import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { trackCategoryView } from '../../utils/analytics';
import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import ArticleCard from '../ArticleCard/ArticleCard';
import NewsletterSignup from '../NewsletterSignup/NewsletterSignup';
import articles from '../Articles/articles';
import categories from '../Categories/categories';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

const Category = () => {
    const { categorySlug = 'nutrition' } = useParams();
    const [category, setCategory] = useState(null);
    const [categoryArticles, setCategoryArticles] = useState([]);

    useEffect(() => {
        const currentCategory = categories.find(c => c.slug === categorySlug);

        if (currentCategory) {
            setCategory(currentCategory);

            trackCategoryView(currentCategory.name);

            const filteredArticles = articles.filter(
                a => a.category.toLowerCase() === currentCategory.name.toLowerCase()
            );

            setCategoryArticles(filteredArticles);
        }
    }, [categorySlug]);

    if (!category) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <SEO
                title={`${category.name} Articles - SmartLifeChoice`}
                description={category.description}
                url={`/category/${categorySlug}`}
                keywords={`${category.name.toLowerCase()}, ${category.name.toLowerCase()} articles, ${category.name.toLowerCase()} tips, health, fitness, wellness`}
            />
            <Header />

            <main className="main">
                <div className="container">
                    <section className="category-hero" style={{
                        backgroundImage: `url(${category.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: 'var(--radius-lg)',
                        padding: 'var(--space-6)',
                        marginBottom: 'var(--space-4)',
                        position: 'relative',
                        color: 'white',
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0,0,0,0.6)',
                            borderRadius: 'var(--radius-lg)',
                        }}></div>
                        <div style={{ position: 'relative', zIndex: 1 }}>
                            <h1 style={{ fontSize: '2.5rem', marginBottom: 'var(--space-2)' }}>{category.name}</h1>
                            <p style={{ fontSize: '1.25rem', maxWidth: '800px' }}>{category.description}</p>
                        </div>
                    </section>

                    <section className="article-list">
                        <h2 className="section-title">{category.name} Articles</h2>

                        {categoryArticles.length === 0 ? (
                            <p className="text-center mt-4">No articles found in this category.</p>
                        ) : (
                            <div className="article-grid">
                                {categoryArticles.map(article => (
                                    <ArticleCard key={article.id} article={article} />
                                ))}
                            </div>
                        )}
                    </section>
                </div>

                <NewsletterSignup />
            </main>

            <Footer />
        </div>
    );
};

export default Category;
